var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrainingTab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.600911 6.80078H2.01758V11.0009H0.600911V6.80078Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.21992 10.1114C8.499 10.2374 8.79437 10.3004 9.09896 10.3004C9.40354 10.3004 9.69892 10.2374 9.97729 10.1121L14.7656 7.96094V11.7004C14.7656 13.5387 11.9153 14.5005 9.09896 14.5005C6.28263 14.5005 3.43229 13.5387 3.43229 11.7004V7.96164L8.21992 10.1114Z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.01469 4.06258L8.80636 0.562477C8.99265 0.479174 9.20586 0.479174 9.39215 0.562477L17.1838 4.06258C17.4374 4.17598 17.5996 4.42449 17.5996 4.69959C17.5996 4.9747 17.4374 5.22321 17.1845 5.33661L9.39286 8.83671C9.29936 8.87871 9.19948 8.89971 9.09961 8.89971C8.99973 8.89971 8.89986 8.87871 8.80636 8.83671L1.01469 5.33661C0.761818 5.22321 0.599609 4.9747 0.599609 4.69959C0.599609 4.42449 0.761818 4.17598 1.01469 4.06258Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingTab);
export default __webpack_public_path__ + "static/media/training_tab.e3cb335d66c4907c0968650314fdf65a.svg";
export { ForwardRef as ReactComponent };